import { useLocation, useNavigate } from 'react-router-dom';

import { useCallback } from "react";

const useNavigation = () => {

    const navigate = useNavigate();

    const location = useLocation();

    const navigateToRouteWithData = ({ route, data, from }) => {
        navigate(
            route,
            from ? { state: data, from } : { state: data }
        )
    };

    const navigateToRoute = useCallback((path) => {
        navigate(path);
    }, [navigate]);

    const replaceRoute = useCallback((path) => {
        navigate(path, { replace: true });
    }, [navigate]);

    const goBack = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    const navigateToRouteWithState = useCallback(
        ({ path, state }) => {navigate(path, { state });
    }, [navigate]);

    const getStateFromNavigatedRoute = useCallback(
        () => location.state,
        [location]
    );

    return {
        goBack,
        replaceRoute,
        navigateToRoute,
        navigateToRouteWithState,
        navigateToRouteWithData,
        getStateFromNavigatedRoute,
    };

};

export default useNavigation;